import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { parseUserPathExtra } from "../funnel";
import { formatExtra, formatMessage, get, getPath as _getPath, isObject } from "../utils";
export var Tracker = {
  Tracert: null,
  funnelAuto: true,
  userPathAuto: true,
  spmConfig: {
    spmAPos: '',
    bizType: '',
    pages: {}
  },
  spmInfo: {},
  getPath: function getPath() {
    return _getPath();
  },
  loadSpm: function loadSpm(page) {
    var _Tracker$spmConfig, _Tracker$Tracert, _Tracker$spmConfig$sp, _Tracker$spmConfig2;
    var extraParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var autoPv = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // if (typeof page === 'string') {
    var spmInfo = (_Tracker$spmConfig = Tracker.spmConfig) === null || _Tracker$spmConfig === void 0 ? void 0 : _Tracker$spmConfig.pages[page];
    // 直接传'a.b'，不使用spmConfig情况
    if (!spmInfo) {
      var spmInfoPage = page.split('.');
      if (spmInfoPage.length !== 2) {
        console.error('page is invalid');
        return false;
      }
      Tracker.spmInfo = {
        spmA: spmInfoPage[0],
        spmB: spmInfoPage[1]
      };
    } else {
      Tracker.spmInfo = spmInfo;
    }
    (_Tracker$Tracert = Tracker.Tracert) === null || _Tracker$Tracert === void 0 ? void 0 : _Tracker$Tracert.set({
      spmAPos: (_Tracker$spmConfig$sp = (_Tracker$spmConfig2 = Tracker.spmConfig) === null || _Tracker$spmConfig2 === void 0 ? void 0 : _Tracker$spmConfig2.spmAPos) !== null && _Tracker$spmConfig$sp !== void 0 ? _Tracker$spmConfig$sp : Tracker.spmInfo.spmA,
      spmBPos: Tracker.spmInfo.spmB,
      currentPage: page,
      url: Tracker.getPath()
    });
    if (autoPv) {
      var _Tracker$Tracert4;
      var extraData = extraParams;
      if (Tracker.funnelAuto) {
        var _Tracker$Tracert2, _Tracker$Tracert3;
        extraData = _objectSpread({
          funnel_level_alias: "".concat((_Tracker$Tracert2 = Tracker.Tracert) === null || _Tracker$Tracert2 === void 0 ? void 0 : _Tracker$Tracert2.spmAPos, ".").concat((_Tracker$Tracert3 = Tracker.Tracert) === null || _Tracker$Tracert3 === void 0 ? void 0 : _Tracker$Tracert3.spmBPos)
        }, extraData);
      }
      if (Tracker.userPathAuto) {
        extraData = _objectSpread(_objectSpread({}, parseUserPathExtra("p_".concat(page))), extraData);
      }
      (_Tracker$Tracert4 = Tracker.Tracert) === null || _Tracker$Tracert4 === void 0 ? void 0 : _Tracker$Tracert4.logPv(extraData);
    }
  },
  /**
   * 点击上报
   * @param code 点击code
   * @param extra 额外的参数，传入的所有额外信息均会落入 extInfo4 字段
   */
  spmClick: function spmClick(code) {
    var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var seed = (Tracker === null || Tracker === void 0 ? void 0 : Tracker.spmInfo[code]) || code;
    var extraData = extra;
    if (Tracker.funnelAuto) {
      var _Tracker$Tracert5, _Tracker$Tracert6;
      extraData = _objectSpread({
        funnel_level_alias: seed.split('.').length > 2 ? seed : "".concat((_Tracker$Tracert5 = Tracker.Tracert) === null || _Tracker$Tracert5 === void 0 ? void 0 : _Tracker$Tracert5.spmAPos, ".").concat((_Tracker$Tracert6 = Tracker.Tracert) === null || _Tracker$Tracert6 === void 0 ? void 0 : _Tracker$Tracert6.spmBPos, ".").concat(seed)
      }, extra);
    }
    if (Tracker.userPathAuto) {
      extraData = _objectSpread(_objectSpread({}, parseUserPathExtra("click_".concat(seed.split('.').pop()))), extraData);
    }
    if (seed) {
      Tracker === null || Tracker === void 0 ? void 0 : Tracker.Tracert.click(seed, extraData);
    }
  },
  /**
   * 曝光
   * spmExpo('SpmC_More', { deposit_result: 'success' })
   * @param code 页面code
   * @param extra  可以为定义对象，均会埋入ext_info4中
   */
  spmExpo: function spmExpo(code, extra) {
    var extraData = extra;
    var seed = (Tracker === null || Tracker === void 0 ? void 0 : Tracker.spmInfo[code]) || code;
    extraData = _objectSpread(_objectSpread({}, parseUserPathExtra("expo_".concat(seed.split('.').pop()))), extra);
    if (seed) {
      var _Tracker$Tracert7;
      (_Tracker$Tracert7 = Tracker.Tracert) === null || _Tracker$Tracert7 === void 0 ? void 0 : _Tracker$Tracert7.expo(seed, extraData);
    }
  },
  /**
   * tracker上报
   * @param code 监控code
   * @param extra 额外的参数，传入的所有额外信息均会落入 extInfo4 字段
   */
  reportLog: function reportLog(logType, title, msg, extra) {
    var _extra$immediate, _param;
    var param4 = (_param = {}, _defineProperty(_param, "web_".concat(logType, "_title"), title), _defineProperty(_param, "web_".concat(logType, "_message"), formatMessage(msg).join('^')), _defineProperty(_param, "immediate", (_extra$immediate = extra === null || extra === void 0 ? void 0 : extra.immediate) !== null && _extra$immediate !== void 0 ? _extra$immediate : false), _param);
    // 用户路径
    var pathAlias = Tracker.userPathAuto ? title : get(extra, 'userPath', '');

    // msg中如果存在errorCode，单独放到扩展参数
    Object.assign(param4, msg !== null && msg !== void 0 && msg.errorCode ? {
      errorCode: msg.errorCode
    } : {}, Tracker.funnelAuto ? {
      funnel_level_alias: title
    } : {}, Tracker.userPathAuto && pathAlias ? parseUserPathExtra("l_".concat(pathAlias)) : {}, formatExtra(extra));
    try {
      var _Tracker$Tracert8;
      Tracker === null || Tracker === void 0 ? void 0 : (_Tracker$Tracert8 = Tracker.Tracert) === null || _Tracker$Tracert8 === void 0 ? void 0 : _Tracker$Tracert8.log("web_".concat(logType), param4);
    } catch (e) {
      console.error('Monitor error', e);
    }
  },
  reportRPC: function reportRPC(rpcInfo) {
    var _rpcInfo$label;
    var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // 兼容老的数据格式
    if (typeof rpcInfo.success !== 'undefined') {
      // 成功 1 失败 0
      rpcInfo.result = rpcInfo.success ? 1 : 0;
    }
    var errorCode = rpcInfo.code;
    var userPathExtra;
    // rpc上报到用户路径
    if (Tracker.userPathAuto) {
      var rpcMark = rpcInfo.name;
      userPathExtra = parseUserPathExtra("r_".concat(rpcMark, "_").concat(errorCode));
    }
    var immediate = extra.immediate;

    // 上报测速
    Tracker === null || Tracker === void 0 ? void 0 : Tracker.Tracert.log('web_rpc_performance', _objectSpread(_objectSpread({
      basic_ext_param_key: rpcInfo.name,
      operationName: (_rpcInfo$label = rpcInfo.label) !== null && _rpcInfo$label !== void 0 ? _rpcInfo$label : '',
      basic_ext_param_time: rpcInfo.time,
      web_rpc_performance_result_code: rpcInfo.result,
      traceId: rpcInfo.traceId,
      httpStatus: isObject(rpcInfo.httpStatus) ? JSON.stringify(rpcInfo.httpStatus) : rpcInfo.httpStatus,
      errorCode: rpcInfo.code,
      idengine_result: rpcInfo.success ? 1 : 0,
      errorMessage: rpcInfo.msg
    }, userPathExtra), {}, {
      immediate: immediate
    }));
  },
  /**
   * 上报漏斗模型
   * @param config 漏斗配置
   */
  reportFunnel: function reportFunnel(title, config) {
    Tracker === null || Tracker === void 0 ? void 0 : Tracker.reportLog('info', title, '', config);
  },
  set: function set() {
    var _Tracker$Tracert9;
    var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    Tracker === null || Tracker === void 0 ? void 0 : (_Tracker$Tracert9 = Tracker.Tracert) === null || _Tracker$Tracert9 === void 0 ? void 0 : _Tracker$Tracert9.set(opt);
    Object.assign(Tracker, opt);
  }
};